import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button, Div, Text, DefaultTheme } from '@pinpoint/design-kit';

/* eslint-disable react/prop-types */

const BaseButton = styled(Button)`
  &:hover {
    box-shadow: 0 0 1px ${({ theme }) => DefaultTheme.colors[`${theme}400`]},
      0 0 2px ${({ theme }) => DefaultTheme.colors[`${theme}400`]},
      0 0 6px ${({ theme }) => DefaultTheme.colors[`${theme}300`]},
      0 0 8px ${({ theme }) => DefaultTheme.colors[`${theme}300`]},
      0 0 10px ${({ theme }) => DefaultTheme.colors[`${theme}200`]},
      0 0 12px ${({ theme }) => DefaultTheme.colors[`${theme}200`]},
      0 0 14px ${({ theme }) => DefaultTheme.colors[`${theme}100`]};
  }
`;

function RadioButton({ isSelected, onClick, name, theme }) {
  return (
    <BaseButton
      hoverShadow="5"
      bg={isSelected ? `${theme}500` : 'white'}
      border="1px solid"
      borderColor={`${theme}500`}
      m="1rem"
      theme={theme}
      onClick={() => onClick()}
    >
      <Text textColor={isSelected ? 'white' : `${theme}500`}>{name}</Text>
    </BaseButton>
  );
}

/* eslint-enable react/prop-types */

export function ButtonGroup({ options, maxSelection, selected, onClick }) {
  return (
    <Div d="flex" flexWrap="wrap" m={{ y: '1rem' }}>
      {options.map(({ name, theme, id }) => (
        <RadioButton
          onClick={() => {
            if (maxSelection === 0) {
              onClick([]);
            } else {
              const hasRoom = selected.length < maxSelection;
              const values = hasRoom ? [...selected, id] : [...selected.slice(1), id];
              onClick(values);
            }
          }}
          isSelected={selected.includes(id)}
          name={name}
          theme={theme || 'brand'}
        />
      ))}
    </Div>
  );
}

ButtonGroup.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
      theme: PropTypes.string,
    })
  ).isRequired,
  selected: PropTypes.arrayOf(PropTypes.number).isRequired,
  onClick: PropTypes.func.isRequired,
  maxSelection: PropTypes.number,
};

ButtonGroup.defaultProps = {
  maxSelection: 1,
};

export default ButtonGroup;
